module.exports = __webpack_public_path__ + "img/product-placeholder-41.16ddf81.png";